module.exports = __webpack_public_path__ + "media/manual.ef030a30.mp4";